import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, Typography, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useSearchParams, useNavigate } from "react-router-dom";
import EventController from "./Controller/event_controller.ts";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

interface Props {
  autoID: string | null;
  emailContent: string | null;
  emailTemplate: string | null;
}

const EmailPreview:React.FC<Props> = ({ autoID, emailContent, emailTemplate }) => {
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();

  const handleCopy = () => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = (emailContent ? emailContent : ''); // Preserve full HTML

    document.body.appendChild(tempDiv);
    const range = document.createRange();
    range.selectNodeContents(tempDiv);

    const selection = window.getSelection();

    if(selection) {
      selection.removeAllRanges();
      selection.addRange(range);

      document.execCommand("copy"); // Copies as rich HTML
      selection.removeAllRanges();
      document.body.removeChild(tempDiv);

      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    }
  };

  //ui functions
  const OnResendBtnClicked = () => {
    navigate('/admin/event_blast/' + autoID)
  }

  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "#e8e8e8",
        height: "100%",
        minHeight: "150vh",
        width: "100vw",
        overflow: "hidden",
      }}
    >
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          display: "flex",
          flexDirection: "column",
          height: "100%",
          width: "100%",
        }}
      >
        <DrawerHeader />
        <Typography gutterBottom variant="h4" sx={{ color: "text.secondary" }}>
          Email Preview
        </Typography>

        <Card
          sx={{
            maxWidth: 1100,
            margin: "20px auto",
            padding: 2,
            position: "relative", // Make sure the button stays inside the card
          }}
        >
          {/* Copy Button - Positioned Top Right */}
          {/*<Button
            variant="contained"
            onClick={handleCopy}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              backgroundColor: "red",
              color: "white",
              "&:hover": {
                backgroundColor: "#b71c1c", // Darker red on hover
              },
            }}
          >
            {copied ? "Copied!" : "Copy"}
          </Button> ---deprecated*/}
          {
            emailTemplate == "" ?
            <Button
              variant="contained"
              onClick={() => OnResendBtnClicked()}
              sx={{
                position: "absolute",
                top: 10,
                right: 10,
                backgroundColor: "red",
                color: "white",
                "&:hover": {
                  backgroundColor: "#b71c1c", // Darker red on hover
                },
              }}
            >
            Dupplicate
          </Button>
            :
            null
          }

          <CardContent>
            {/* Email Content */}
            <div dangerouslySetInnerHTML={{ __html: (emailContent ? emailContent : '') }} />
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

type EmailData = {
  email_content: string;
  email_template: string | null;
};

const App = () => {
  const [searchParams] = useSearchParams();
  const ID = searchParams.get("ID");
  const [data, setData] = useState<EmailData>({} as EmailData);

  useEffect(() => {
    if (ID) {
      const payload = new FormData();
      payload.append("ID", ID);
      EventController.getBlastHistoryInfo(payload)
        .then((response: any) => {
          setData({
            "email_content" : response['email_content'],
            "email_template": response['email_template']? response['email_template'] : null
          } as EmailData);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [ID]);

  return <EmailPreview emailContent={data.email_content || ""} emailTemplate={data.email_template || ""} autoID={ID}/>;
};

export default App;
